// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3KpJj","header":"MessagesList_header__3h1vz","chat":"MessagesList_chat__1qCBi"};